<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchUserName" style="width:150px;" placeholder="请输入用户名"/>
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchRoleName" style="width:150px;" placeholder="请输入角色"/>
      <Select v-model="searchStatus" style="width:150px;margin-left:25px;" placeholder="请选择状态">
        <Option :value="1">正常</Option>
        <Option :value="0">停用</Option>
      </Select>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box">
      <Button type="primary" @click="newAlert" style="margin-right:5px;">新增</Button>
    </div>
    <div class="app-list-table">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="batchErrArrFlag"
      title="信息提示"
      @on-ok="clearErrArr()"
    >
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :title="editId ? editFlag ? '查看' : '编辑' : '新增'"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="所属角色" prop="roleId">
          <Select
                v-model="formValidate.roleId"
                placeholder="请选择所属角色"
                filterable
                >
                <Option v-for="(option) in permissionList" :value="option.id" :key="option.id">{{option.roleName}}</Option>
            </Select>
            <p style="color:#c00;font-size:12px;">* 用户加入到角色后，将拥有该角色的所有权限。</p>
        </FormItem>
        <FormItem label="用户名" prop="username">
          <Input v-model="formValidate.username" maxlength="20" show-word-limit placeholder="请输入用户名，可包含汉字、字母、数字，不可重复" />
        </FormItem>
        <FormItem label="密码" prop="password">
          <!-- :disabled="editPassword" -->
          <Input v-model="formValidate.password" maxlength="20" show-word-limit placeholder="请输入用户密码，可包含字母、数字" />
        </FormItem>
        <FormItem label="一级审核账号" prop="auditUsername1">
          <Select
                v-model="formValidate.auditUsername1"
                placeholder="请选择一级审核账号，可模糊搜索，可多选"
                filterable
                multiple
                >
                <Option v-for="(option) in auditList" :value="option" :key="option.id">{{option}}</Option>
            </Select>
        </FormItem>
        <FormItem label="二级审核账号" prop="auditUsername2">
          <Select
                v-model="formValidate.auditUsername2"
                placeholder="请选择二级审核账号，可模糊搜索，可多选"
                filterable
                multiple
                >
                <Option v-for="(option) in auditList" :value="option" :key="option.id">{{option}}</Option>
            </Select>
            <p style="color:#c00;font-size:12px;">* 一级审核账号审核通过后流转到二级审核账号，多个账号只需审批通过一次</p>
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio label="正常"></Radio>
            <Radio label="停用"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" placeholder="备注最大字数为50字" maxlength="50" show-word-limit type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      editId: '',
      userList: [],
      userInfoId: '',
      searchUserName: '',
      searchRoleName: '',
      searchStatus: '',
      currentIndex: '',
      isShowSpin: false,
      tableSelectRow: [],
      batchErrArrFlag: false,
      formValidate: {
        roleId: '',
        username: '',
        password: '',
        auditUsername1: '',
        auditUsername2: '',
        remark: '',
        status: '正常'
      },
      ruleValidate: {
        roleId: [
          { required: true, message: '请选择所属角色' }
          // { type: 'string', max: 20, min: 1, message: '请输入角色名称，支持汉字、字母、数字', trigger: 'blur' }
        ],
        username: [{ required: true, message: '请输入用户名，可包含汉字、字母、数字，不可重复', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: '不符合规范,请重新输入', trigger: 'blur' }],
        password: [{ required: true, message: '请输入用户密码，可包含字母、数字', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9*]*$/, message: '不符合规范,请重新输入', trigger: 'blur' }],
        auditUsername1: [{ required: true, message: '请选择一级审核账号，可模糊搜索，可多选' }],
        auditUsername2: [{ required: false, message: '请选择二级审核账号，可模糊搜索，可多选' }],
        // permissionIds: [{ required: true, message: '请选择权限', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态' }]
        // apk_pkg: { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.vibes.test' }
      },
      columns: [ // table表格
        {
          title: '角色',
          key: 'roleName',
          width: 200,
          align: 'center'
        },
        {
          title: '用户名',
          key: 'username',
          width: 200,
          align: 'center'
        },
        {
          title: '一级审核账号',
          key: 'auditUsername1',
          width: 200,
          align: 'center'
        },
        {
          title: '二级审核账号',
          key: 'auditUsername2',
          width: 200,
          align: 'center'
        },
        {
          title: '状态',
          key: 'status',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 0:
                status = '停用'
                break
              case 1:
                status = '正常'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '说明',
          key: 'remark',
          align: 'center',
          width: 300
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width: 200
        },
        {
          title: '更新时间',
          key: 'updateTime',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 220,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (params.row.username === 'admin')
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'lock')
                  }
                }
              }, '编辑')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small',
              //     disabled: (params.row.username === 'admin')
              //   },
              //   style: {
              //     width: '70px',
              //     marginRight: '10px'
              //   },
              //   on: {
              //     click: () => {
              //       this.newAlert(params.index, 'lock')
              //     }
              //   }
              // }, '查看')
            ])
          }
        }
      ],
      parentUsername: '',
      auditList: [],
      editFlag: false,
      editPassword: false,
      permissionList: [],
      categoryList: [],
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.parentUsername = this.$route.query.parentUsername
    this.loadData()
    this.getPermissionList()
    this.getAuditListList()
  },
  mounted () {
  },
  methods: {
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchUserName = ''
      this.searchRoleName = ''
      this.searchStatus = ''
      this.loadData()
    },
    clearUserId () {
      this.loadData()
    },
    // 加载tabs列表
    loadData (id = '') {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.current,
        roleName: this.searchRoleName,
        parentUsername: `${this.parentUsername}`,
        username: `${this.searchUserName}`,
        status: `${this.searchStatus}`
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        url: 'user/list',
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        },
        params: params
      }).then(res => {
        console.log(res)
        this.tableLoading = false
        this.isShowSpin = false
        this.dataList = res.data.records
        this.total = res.data.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    newAlert (index, flag = 'noLock') {
      this.$refs['formValidate'].resetFields()
      if (!isNaN(index)) {
        console.log(index, this.dataList)
        this.formValidate = {
          roleId: this.dataList[index].roleId,
          remark: this.dataList[index].remark,
          status: this.dataList[index].status === 1 ? '正常' : '停用',
          username: this.dataList[index].username,
          password: '******',
          auditUsername1: this.dataList[index].auditUsername1 === null ? [] : this.dataList[index].auditUsername1.split(','),
          auditUsername2: this.dataList[index].auditUsername2 === null ? [] : this.dataList[index].auditUsername2.split(',')
        }
        this.editId = this.dataList[index].id
        this.currentIndex = index
        this.editFlag = false
        this.editPassword = (flag === 'lock')
      } else {
        this.editId = ''
        this.editFlag = false
        this.editPassword = false
      }
      this.newdata = true
    },
    clearErrArr () {
      this.batchErrArrFlag = false
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            // if (this.formValidate.roleId.length === 0) {
            //   this.$Message.error('卡片名称不能为空')
            //   return
            // }
            let flag = false
            if (this.formValidate.auditUsername1) {
              const auditUsername2Values = this.formValidate.auditUsername2 || []
              this.formValidate.auditUsername1.forEach(option => {
                if (auditUsername2Values.includes(option)) {
                  flag = true
                }
              })
            }
            if (flag) {
              this.$Message.error('一级审核与二级审核重复!')
              return
            }
            let params = {
              roleId: this.formValidate.roleId,
              username: this.formValidate.username,
              parentUsername: this.parentUsername,
              password: this.formValidate.password === '******' ? '' : this.formValidate.password,
              auditUsername1: this.formValidate.auditUsername1.join(),
              auditUsername2: this.formValidate.auditUsername2 ? this.formValidate.auditUsername2.join() : '',
              status: this.formValidate.status === '正常' ? 1 : 0,
              remark: this.formValidate.remark
            }
            if (this.editId) {
              params['id'] = this.editId
              https.request({
                method: 'post',
                url: 'user/edit',
                headers: {
                  'Content-Type': 'application/json',
                  'satoken': https.token
                },
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 400) {
                  this.$Message.error(res.msg)
                  this.newdata = false
                  this.loadData()
                  return
                }
                if (res && res.code === 500) {
                  this.$Message.error(res.msg)
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              console.log(params)
              https.request({
                method: 'post',
                url: 'user/add',
                headers: {
                  'Content-Type': 'application/json',
                  'satoken': https.token
                },
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 500) {
                  this.$Message.error(res.msg)
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    getAuditListList () {
      let params = {
        pageSize: 100,
        pageNo: 1
        // username: https.userName
      }
      https.request({
        method: 'get',
        url: `user/auditList`,
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        },
        params: params
      }).then(res => {
        console.log(res)
        this.auditList = res.data
      })
    },
    getPermissionList () {
      let params = {
        pageSize: 100,
        pageNo: 1
        // status: 1
      }
      https.request({
        method: 'get',
        url: 'role/list',
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        },
        params: params
      }).then(res => {
        console.log(res)
        let arr = []
        res.data.records.map(item => {
          if (item.status === 1) {
            arr.push(item)
          }
        })
        this.permissionList = arr
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    right: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:207px;
    // left:407px;
  }
  .input_left_two{
    left:380px;
    // left:580px;
  }
  .input_left_three{
    left:735px;
    // left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:40px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
  .permission_son{
    margin-left:20px;
  }
  .permission_son_s{
    margin-left:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/authority/subUser.vue